import React from "react";
import "./Trending_card.css";
import { formatDate } from "../../../../../utils/common";
import { useNavigate } from "react-router-dom";

function Trending_card({ imgSrc, val }) {
  const navigate = useNavigate();
  return (
    <>
      <section
        className="Trending_card"
        onClick={() => navigate(`/luxury/latest-news-details/${val?.id}`)}
      >
        <div className="img_holder">
          <img src={imgSrc} alt="Trending img" className="Trending_img" />
        </div>

        <div className="text_holder">
          <h1>{val?.name}</h1>

          <div className="date_text_holder">
            <p className="mb-2">
              By <span>{val?.by_name}</span>
              {/* and <span>William</span>{" "} */}
            </p>

            <div className="date_holder">
              <p>{formatDate(val?.createdAt)}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Trending_card;
